	<template>
		<div class="personal">
			<div class="mine-container bg-black animation-scale-down">
				<div></div>
				<header>
					<div style="display: block;">
						<div class="cu-custom" style="height: 45px;">
							<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
								<div class="content text-gold" style="top: 0px;">
									<div>{{$t('qianbao')}}</div>
								</div>
								<div style="margin-left: 34px;" @click="changeLanguage">
									<text style="margin-left: -20px; font-size: 14px;">
										<span>{{$t('jiantizhongwen')}}</span>
									</text>
								</div>
							</div>
						</div>
					</div>
				</header>
				<div class="header-section animation-scale-down" style="height: 215px;">
					<div class="flex justify-between" style="padding-left: 10%; padding-top: 10px;">
						<div class="flex align-center">
							<!-- <img class="cu-avatar xl round" src="@/assets/image/a1.jpg"
								style="width: 70px; height: 70px;background-size: 100% 100%;background-repeat: no-repeat;"> -->
							<div class="avatar-container" @click="goToAvatar">
								<img :src="avatar" alt="用户头像" class="avatar">
							</div>
							<div class="user-info text-gold">
								<div class="u_title text-gold" style="font-size: 20px;">{{ user.username }}</div>
								<div class="cu-tag " style="border-radius: 5px; width: 68px; height: 21px;"
									:class="{  'bg-gradual-black':user.level === '至尊','bg-gradual-blue': user.level === '基础',  'bg-gradual-orange': user.level === '普通', 'bg-gradual-red': user.level === '贵宾',   'bg-gradual-purple': user.level === '专业'  }">
									<div class="cu-tag badge cuIcon-vip bg-blue"
										style="border-radius: 5px; width: 11px; height: 11px;"></div>
									<text class="cuIcon-favor" style="font-size: 14px;">
										<span>{{ $t(userLevel) }}</span>
									</text>
								</div>
							</div>
						</div>
						<div class="flex align-center text-gold" style="padding-right: 10%;" v-if="user.codeqq === 1">
							<div class="cu-tag bg-gradual-green text-xs margin-left-lg round" style="margin-bottom: 5px;">
								<text class="cuIcon-roundcheckfill">
									<span>{{ $t('yirenz') }}</span>
								</text>
							</div>
						</div>
						<div class="flex align-center text-gold" style="padding-right: 10%;" v-if="user.codeqq === 0">
							<div class="cu-tag bg-grey text-xs margin-left-lg round" style="margin-bottom: 5px;">
								<text class="cuIcon-roundcheckfill">
									<span>{{ $t('weirenzz') }}</span>
								</text>
							</div>
						</div>
					</div>
					<div style="padding-top: 25px; padding-left: 15%; color: rgb(111, 87, 43); font-size: 16px;">
						<text>
							<span style="margin-left: -180px;">{{ $t('zican') }}</span>
						</text>
						<text style="float: right; padding-right: 15%;">
							<span>{{ $t('jinrisunyi') }}</span>
						</text>
					</div>
					<div
						style="padding-top: 10px; padding-left: 15%; color: rgb(111, 87, 43); font-size: 16px; font-weight: bolder;">
						<text><span style="float: left;">{{ user.money }}</span></text>
						<text style="float: right; padding-right: 15%;">{{ user.profit }}</text>
					</div>
				</div>
				<div class="content-section" style="margin-top: -50px;">
					<div class="mine-actions grid col-3 text-center bg-gradual-black">
						<div class="action-item text-gold" @click="changezhuanchu">
							<div class="cuIcon-pay icon cu-avatar text-gold"
								style="background-color: rgba(0, 0, 0, 0); font-size: 40px;"></div>
							<div class="text">{{ $t('zhuanchu') }}</div>
						</div>
						<div class="action-item text-gold" @click="changewa">
							<div class="cuIcon-card  icon cu-avatar text-gold"
								style="background-color: rgba(0, 0, 0, 0); font-size: 40px;"></div>
							<text class="text">
								<span>{{ $t('cunru') }}</span>
							</text>
						</div>
						<div class="action-item text-gold" @click="changeXtgg">
							<div class="notification-container">
								<div class="cuIcon-notice text-gold icon cu-item cu-avatar"
									style="background-color: rgba(0, 0, 0, 0);"></div>
								<span v-if="user.sendMessage > 0" class="message-badge"> ！</span>
							</div>
							<text class="text">
								<span>{{ $t('xitongxx') }}</span>
							</text>
						</div>
					</div>
				</div>
				<div class="content-section">
					<div class="mine-actions grid col-4 text-center bg-gradual-black">
						<div class="action-item text-gold" @click="handleKefuClick">
							<div class="iconfont icon-service icon cu-avatar text-gold"
								style="background-color: rgba(0, 0, 0, 0);"><van-icon name="service-o" /></div>
							<text class="text">
								<span>{{ $t('zaixian') }}</span>
							</text>
						</div>
						<div class="action-item text-gold" @click="changeTouzi">
							<div class=" cuIcon-calendar text-gold icon cu-avatar"
								style="background-color: rgba(0, 0, 0, 0);"></div>
							<text class="text">
								<span>{{$t ('touzimx')}}</span>
							</text>
						</div>
						<div class="action-item text-gold" @click="changeZijin">
							<div class="cuIcon-pay text-gold icon  cu-avatar" style="background-color: rgba(0, 0, 0, 0);">
							</div>
							<text class="text">
								<span>{{ $t('zijinminxi') }}</span>
							</text>
						</div>
						<div class="action-item text-gold" @click="changeRule">
							<div class="cuIcon-favor text-gold icon cu-item cu-avatar"
								style="background-color: rgba(0, 0, 0, 0);"></div>
							<text class="text">
								<span>{{$t('jiaoyiguize')}}</span>
							</text>
						</div>
						<div class="action-item text-gold" style="margin-top: 20px;" @click="changeAnquan">
							<div class="cuIcon-safe text-gold icon  cu-avatar" style="background-color: rgba(0, 0, 0, 0);">
							</div>
							<text class="text">
								<span>{{$t('anquanzhongxin')}}</span>
							</text>
						</div>
						<div class="action-item text-gold" style="margin-top: 20px;" @click="changeNotice">
							<div class="cuIcon-notification text-gold icon  cu-avatar"
								style="background-color: rgba(0, 0, 0, 0);"></div>
							<text class="text">
								<span>{{ $t('pingtaigonggao') }}</span>
							</text>
						</div>
						<div class="action-item text-gold" style="margin-top: 20px;" @click="changeRenz">
							<div class="cuIcon-people text-gold icon  cu-avatar"
								style="background-color: rgba(0, 0, 0, 0);"></div>
							<text class="text">
								<span>{{$t('renzhengzx')}}</span>
							</text>
						</div>
						<div class="action-item text-gold" style="margin-top: 20px;" @click="changeabout">
							<div class="iconfont icon-aixin text-gold icon cu-avatar"
								style="background-color: rgba(0, 0, 0, 0);"><van-icon name="like-o" /></div>
							<text class="text">
								<span>{{$t('guanyuwomen')}}</span>
							</text>
						</div>
					</div>
				</div>
				<div class="padding flex flex-direction"
					style="padding-top: 0px; border-bottom: 1px solid rgba(255,255,255,0.3); " @click="changelogin">
					<button class="cu-btn bg-gradual-black margin-tb-sm lg text-gold">{{ $t('tuichudenglu') }}</button>
				</div>
				<div class="cu-modal " :class="{'show': showTransferModal}" @click.self="showTransferModal = false">
					<div class="cu-dialog" style="width: 60%;">
						<div class="cu-list menu">
							<div class="cu-item text-gold" @click="widt">
								<label class="flex justify-between align-center flex-sub uni-label-pointer">
									<div class="flex-sub">USDT-TRC20</div>
								</label>
							</div>
							<div class="cu-item text-gold" @click="widt1">
								<label class="flex justify-between align-center flex-sub uni-label-pointer">
									<div class="flex-sub">USDT-ERC20</div>
								</label>
							</div>
							<div class="cu-item text-gold" @click="widt2">
								<label class="flex justify-between align-center flex-sub uni-label-pointer">
									<div class="flex-sub">BTC</div>
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="cu-modal" :class="{'show': showDepositModal}" @click.self="showDepositModal = false">
					<div class="cu-dialog " style="width: 60%;">
						<div class="cu-list menu">
							<div class="cu-item text-gold" @click="tixian">
								<label class="flex justify-between align-center flex-sub uni-label-pointer">
									<div class="flex-sub">USDT-TRC20</div>
								</label>
							</div>
							<div class="cu-item text-gold" @click="tixian1">
								<label class="flex justify-between align-center flex-sub uni-label-pointer">
									<div class="flex-sub">USDT-ERC20</div>
								</label>
							</div>
							<div class="cu-item text-gold" @click="tixian2">
								<label class="flex justify-between align-center flex-sub uni-label-pointer">
									<div class="flex-sub">BTC</div>
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="cu-modal " :class="{'show': showLangModal}" @click.self="showLangModal = false">
					<div class=" cu-dialog" style="width: 60%;">
						<div class="cu-list menu">
							<div class="cu-item text-gold" @click="languageSet(3)">
								<label class="flex justify-between align-center flex-sub uni-label-pointer" value="en">
									<div class="flex-sub">English</div>
								</label>
							</div>
							<div class="cu-item text-gold" @click="languageSet(2)">
								<label class="flex justify-between align-center flex-sub uni-label-pointer"
									value="zh-Hans">
									<div class="flex-sub">繁體中文</div>
								</label>
							</div>
							<div class="cu-item text-gold" @click=" languageSet(1)">
								<label class="flex justify-between align-center flex-sub uni-label-pointer"
									value="zh-Hant">
									<div class="flex-sub">简体中文</div>
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<tab-bar></tab-bar>
		</div>
	</template>
	<script>
		import TabBar from "@/components/tabbar/TabBar.vue";
		import userApi from "@/api/user";
		import storeAction from "@/store/typed-actions";
		import homeApi from "@/api/home";
		export default {
			name: "Personal",
			components: {
				TabBar,
			},
			data() {
				return {
					isLoading: false,
					user: "",
					showLangModal: false,
					showTransferModal: false,
					showDepositModal: false,
					avatar: localStorage.getItem('userAvatar') || require('@/assets/image/a1.jpg'),
					// userLevel: '基础’, // 默认值
					messageCount: 2,
				};
			},
			methods: {
				changeXtgg() {
					userApi.checkMessageUser().then(() => {
						// console.log(data.data, 1111);
						this.$router.push({
							path: "/Xtgg",
						});
					});
				},
				goToAvatar() {
					this.$router.push({
						path: '/avatar',
						query: {
							currentAvatar: this.avatar
						}
					})
				},
				tixian() {
					this.$router.push({
						path: "/tixian",
					});
				},
				tixian1() {
					this.$router.push({
						path: "/tixian1",
					});
				},
				tixian2() {
					this.$router.push({
						path: "/tixian2",
					});
				},
				widt() {
					this.$router.push({
						path: "/withdraw1",
					});
				},
				widt1() {
					this.$router.push({
						path: "/withdraw2",
					});
				},
				widt2() {
					this.$router.push({
						path: "/withdraw3",
					});
				},
				languageSet(type) {
					if (type == 0) {
						localStorage.setItem("locale", "zh");
						localStorage.setItem("localetype", type);
						this.show = 0;
					} else if (type == 1) {
						localStorage.setItem("locale", "zh");
						localStorage.setItem("localetype", type);
						this.show = 1;
					} else if (type == 2) {
						localStorage.setItem("locale", "tw");
						localStorage.setItem("localetype", type);
						this.show = 2;
					} else if (type == 3) {
						localStorage.setItem("locale", "en");
						localStorage.setItem("localetype", type);
						this.show = 3;
					}
					location.reload();
				},
				changewa() {
					this.showDepositModal = true
				},
				changezhuanchu() {
					this.showTransferModal = true
				},
				handleKefuClick() {
					homeApi.heart("", "")
						.then((data) => {
							// console.log(data, 33322)
							if (data.data.kefu_config) {
								window.location.href = data.data.kefu_config
								// window.open(data.data.kefu_config); // 新窗口打开链接
								// 或使用 location.href = data.data.kefu_config 当前页跳转
							}
						})
						.catch((err) => {
							this.$toast.fail(err);
						});
				},
				onRefresh() {
					this.$toast.loading({
							message: this.$t('jiazaizhong'),
							forbidClick: true,
							duration: 0,
						}),
						userApi.userInfo().then((data) => {
						
							this.userLevel = data.msg.level;
							this.user = data.msg;
								// console.log(this.user, 11122);
							storeAction.setCurrentUserMoney(data.msg.money);
							storeAction.setCurrentUserGroup_id(data.msg.group_id);
							storeAction.setsessionStorage("money", data.msg.money);
							storeAction.setsessionStorage("group_id", data.msg.group_id);
							storeAction.setsessionStorage("idcard", data.msg.idcard);
							storeAction.setCurrentUserusercrud(data.msg.idcard);
							this.isLoading = false;
							this.$toast.clear();
						});
				},
				changestting(type) {
					this.$router.push({
						path: "/setting",
						query: {
							type: type,
						},
					});
				},
				changebaseinfo() {
					this.$router.push({
						path: "/baseinfo",
						query: {
							name: this.user.username,
						},
					});
				},
				changeActionCenter() {
					this.$router.push({
						path: "/actionCenter",
					});
				},
				changeShareFriend() {
					this.$router.push({
						path: "/shareFriend",
					});
				},
				changeNotice() {
					this.$router.push({
						path: "/Notice",
					});
				},
				changeBet() {
					this.$router.push({
						path: "/BetRecord",
					});
				},
				changeZijin() {
					this.$router.push({
						path: "/Zijin",
					});
				},
				changeWithdraw() {
					this.$router.push({
						path: "/Withdraw",
						query: {
							group_id: this.user.group_id,
						},
					});
				},
				changeLanguage() {
					this.showLangModal = true
					// this.$router.push({
					// 	path: "/language",
					// });
				},
				changeRecharge() {
					this.$router.push({
						path: "/Recharge",
						query: {
							group_id: this.user.group_id,
						},
					});
				},
				changeRenz() {
					this.$router.push({
						path: "/renz",
					});
				},
				changeabout() {
					this.$router.push({
						path: "/about",
					});
				},
				changeAnquan() {
					this.$router.push({
						path: "/anquan",
					});
				},
				changeRule() {
					this.$router.push({
						path: "/rule",
					});
				},
				changeTouzi() {
					this.$router.push({
						path: "/Touzi",
					});
				},

				changego() {
					this.$router.go(-1);
				},
				changelogin() {
					this.$toast.loading({
						message: this.$t('jiazaizhong'),
						forbidClick: true,
						duration: 0,
					});
					this.$router.push({
						path: "/login",
					});
					this.$toast.clear();
				},

			},
			created() {
				this.onRefresh();
				if (this.$route.query.newAvatar) {
					this.avatar = this.$route.query.newAvatar
					localStorage.setItem('userAvatar', this.avatar)
				}
			},
		};
	</script>

	<style src="@/assets/iconfont.css" scoped></style>

	<style>
		.notification-container {
			position: relative;
			display: inline-block;
		}

		.message-badge {
			position: absolute;
			top: -5px;
			right: -5px;
			background-color: red;
			color: white;
			border-radius: 50%;
			width: 18px;
			height: 18px;
			font-size: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: bold;
		}

		.bg-grey {
			background-color: #8799a3;
			color: #fff;
		}

		.personal-page {
			padding: 20px;
		}

		.avatar-container {
			width: 70px;
			height: 70px;
			cursor: pointer;
		}

		.avatar {
			width: 100%;
			height: 100%;
			border-radius: 50%;
			object-fit: cover;
			border: 2px solid white;
			/* 添加白色边框 */

			/* 可选：添加轻微阴影增强立体感 */
		}

		.cu-modal.show {
			opacity: 1;
			pointer-events: auto;
			transform: scale(1);
		}

		.cu-custom {
			display: block;
			position: relative;
			box-sizing: border-box;
		}

		.bg-gradual-black {
			background-image: linear-gradient(45deg, #191a1a, #8799a3);
			color: #b8a78a;
		}

		.cu-bar .content {
			position: absolute;
			text-align: center;
			width: calc(100% - 194px);
			left: 0;
			right: 0;
			bottom: 0;
			top: 0;
			margin: auto;
			height: 34px;
			font-size: 17px;
			line-height: 34px;
			cursor: none;
			pointer-events: none;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}

		.cu-bar {
			display: flex;
			position: relative;
			align-items: center;
			min-height: 57px;
			justify-content: space-between;
		}

		.cu-bar.fixed,
		.nav.fixed {
			position: fixed;
			width: 100%;
			top: 0;
			z-index: 1024;
			box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
		}

		.cu-custom .cu-bar {
			min-height: 0;
			box-shadow: 0px 0px 0px;
			z-index: 9999;
		}

		.cu-custom .cu-bar .content {
			width: calc(100% - 252px);
		}

		.mine-container .header-section {
			background-image: url(../assets/image/a2.jpg);
			background-repeat: no-repeat;
			background-position: 50%;
			background-size: cover;
		}

		.justify-between {
			justify-content: space-between;
		}

		.align-center {
			align-items: center;
		}

		.flex {
			display: flex;
		}

		.mine-container .header-section .cu-avatar {
			border: 2px solid #eaeaea;
		}

		.cu-avatar.xl {
			width: 73px;
			height: 73px;
			font-size: 2.5em;
		}

		.cu-avatar {
			font-variant: small-caps;
			margin: 0;
			padding: 0;
			display: inline-flex;
			text-align: center;
			justify-content: center;
			align-items: center;
			background-color: #ccc;
			color: #fff;
			white-space: nowrap;
			position: relative;
			width: 36px;
			height: 36px;
			background-size: cover;
			background-position: 50%;
			vertical-align: middle;
			font-size: 1.5em;
		}

		.round {
			border-radius: 2866px;
		}

		.mine-container .header-section .cu-avatar {
			border: 2px solid #eaeaea;
		}

		.mine-container .header-section .user-info {
			margin-left: 15px;
		}

		.text-gold,
		.line-gold,
		.lines-gold {
			color: #b8a78a;
		}

		.mine-container .header-section .user-info .u_title {
			font-size: 16px;
			line-height: 30px;
		}

		.cu-tag {
			font-size: 13px;
			vertical-align: middle;
			position: relative;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
			padding: 0px 9px;
			height: 27px;
			font-family: Helvetica Neue, Helvetica, sans-serif;
			white-space: nowrap;
		}

		.cu-tag[class*="cuIcon-"] {
			width: 18px;
			height: 18px;
			top: -2px;
			right: -2px;
		}

		.cu-tag.badge {
			border-radius: 114px;
			position: absolute;
			top: -5px;
			right: -5px;
			font-size: 11px;
			padding: 0px 5px;
			height: 16px;
			color: #fff;
		}

		.cuIcon-vip:before {
			content: "\e6c3";
		}

		[class*="cuIcon-"] {
			font-family: cuIcon;
			font-size: inherit;
			font-style: normal;
		}

		.cuIcon-favor:before {
			content: "\e64c";
		}

		.align-center {
			align-items: center;
		}

		.text-xs {
			font-size: 11px;
		}

		.bg-gradual-green {
			background-image: linear-gradient(45deg, #39b54a, #8dc63f);
			color: #fff;
		}

		.margin-left-lg {
			margin-left: 22px;
		}

		.cuIcon-roundcheckfill:before {
			content: "\e656";
		}

		[class*=animation-] {
			-webkit-animation-duration: .5s;
			animation-duration: .5s;
			-webkit-animation-timing-function: ease-out;
			animation-timing-function: ease-out;
			-webkit-animation-fill-mode: both;
			animation-fill-mode: both;
		}

		body {
			background-color: #f1f1f1;
			font-size: 16px;
			color: #333;
			font-family: Helvetica Neue, Helvetica, sans-serif;
		}

		div {
			box-sizing: border-box;
		}

		.cuIcon-pay:before {
			content: "\e673";
		}

		.cuIcon-card:before {
			content: "\e624";
		}

		.cuIcon-notice:before {
			content: "\e70a";
		}

		.cuIcon-calendar:before {
			content: "\e74a";
		}

		.cuIcon-pay:before {
			content: "\e673";
		}

		.cuIcon-favor:before {
			content: "\e64c";
		}

		.cuIcon-safe:before {
			content: "\e769";
		}

		.cuIcon-notification:before {
			content: "\e66b";
		}

		.cuIcon-people:before {
			content: "\e736";
		}



		.bg-black {
			background-color: #333;
			color: #fff;
		}

		.mine-container .content-section {
			position: relative;
		}

		.mine-container .content-section .mine-actions {
			margin: 15px 15px;
			padding: 20px 0;
			border-radius: 8px;
			background-color: #fff;
		}

		.text-center {
			text-align: center;
		}

		.grid {
			display: flex;
			flex-wrap: wrap;
		}

		.grid.col-3>div {
			width: 33.33%;
		}

		.text-gold,
		.line-gold,
		.lines-gold {
			color: #b8a78a;
		}

		.mine-container .content-section .mine-actions .action-item .icon {
			font-size: 28px;
		}

		.mine-container .content-section .mine-actions .action-item .text {
			display: block;
			font-size: 13px;
			margin: 8px 0;
		}

		.grid.col-4>div {
			width: 25%;
		}

		.iconfont {
			font-family: iconfont !important;
			font-size: 16px;
			display: inline-block;
			font-style: normal;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
		}

		.padding {
			padding: 17px;
		}

		.flex-direction {
			flex-direction: column;
		}

		.cu-btn.lg {
			padding: 0 22px;
			font-size: 18px;
			height: 45px;
		}


		.cu-modal {
			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			z-index: 1110;
			opacity: 0;
			outline: 0;
			text-align: center;
			transform: scale(1.185);
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			perspective: 1146px;
			background: rgba(0, 0, 0, .6);
			transition: all .3s ease-in-out 0s;
			pointer-events: none;
		}

		.cu-btn {
			border-radius: 5px;
			position: relative;
			border: 0px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
			padding: 0 17px;
			font-size: 16px;
			height: 36px;
			line-height: 1;
			text-align: center;
			text-decoration: none;
			overflow: visible;
			margin-left: 0;
			-webkit-transform: translate(0px, 0px);
			transform: translate(0px, 0px);
			margin-right: 0;
		}

		.margin-tb-sm {
			margin-top: 11px;
			margin-bottom: 15px;
		}

		.cu-modal.show {
			opacity: 0;
			transition-duration: .3s;
			-ms-transform: scale(1);
			-webkit-transform: scale(1);
			transform: scale(1);
			overflow-x: hidden;
			overflow-y: auto;
			pointer-events: auto;
		}
	</style>